<template>

    <Head title="Prova"></Head>

    <div class="scale-adjust">
        <div class="student_info container-fluid mb-5 py-2">
            <div class="row">
                <div class="col-sm-12 col-md-6 d-flex justify-content-start align-items-center">
                    <span style="float: left">
                        {{ props.nomeAluno }} / cpf: {{ props.cpfAluno }}
                    </span>
                </div>
                <div class="col-sm-12 col-md-6 d-flex justify-content-end align-items-center">
                    <span class="me-4">Questões: {{ props.totalAnswered }}/{{ props.totalQuestions }}</span>
                    <span class="me-4">
                        Tempo restante:
						<deadline_timer
							:get_time_url="props.get_time_url"
							:get_timer_data_url="props.get_timer_data_url"
							:deadline="props.deadline"
						/>
                    </span>
                    <span class="me-4">
                        <a :href="logout_exam_url" class="btn btn-outline btn-sm btn-logout">Sair</a></span>
                </div>
            </div>
        </div>
    </div>

<div class="container-fluid mt-3">
    <div class="row">
        <div class="col-md-6">
            <student_info
                :nomeAluno="props.nomeAluno"
                :cpfAluno="props.cpfAluno"
                :computerUID="props.computerUID"
                :totalAnswered="props.totalAnswered"
                :totalQuestions="props.totalQuestions"
                :deadline="props.deadline"
                :streaming_source="props.webcam_webrtc_streaming_source"
                :streaming_auth_credential="props.streaming_auth_credential"
                :browser_webcam_streaming_enabled="props.browser_webcam_streaming_enabled"
                :ws_webcam="props.ws_webcam"
            />
        </div>
        <div class="col-md-6">
            <questions
                :questionsInfo="questionInfoSorted"
                :activeQuestion="props.activeQuestion"
            />
        </div>
    </div>
    <div class="row">
        <active_question
            :showCorrectOption="props.show_correct_option"
            :key="key_active_question"
            :activeQuestion="props.activeQuestion"
            :questionOptions="props.questionOptions"
            :questionsInfo="questionInfoSorted"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { usePage } from '@inertiajs/vue3';
import deadline_timer from '../../../components/deadline_timer.vue';
import active_question from '../../../components/Exam/active_question.vue';
import student_info from '../../../components/Exam/student_info.vue';
import questions from '../../../components/Exam/questions.vue';
import { TestQuestion } from 'resources/js/Interfaces/TestQuestion';
import { ActiveQuestion } from 'resources/js/Interfaces/ActiveQuestion';
import {
    PropType,
    computed,
    inject,
    onMounted,
    ref,
    onUpdated,
} from 'vue';
import { QuestionOption } from 'resources/js/Interfaces/QuestionOption';
import { router } from '@inertiajs/core';
import { commonStore } from '../../../stores/common';
import { Head } from '@inertiajs/vue3';
import Swal from 'sweetalert2';
import { checkConnection, checkComputerUUID } from '../../../websockets/WebsocketVerification';

const emitter: any = inject('emitter');
const common = commonStore();

const connectionSpinner = ref(true);
const connectionStatus = ref({
    connection: false,
    verified: false,
});

const props = defineProps({
    nomeAluno: { type: String, required: true },
    cpfAluno: { type: String, required: true },
    computerUID: { type: String, required: true },
    computerId: { type: Number, required: true },
    totalQuestions: { type: Number, required: true },
    totalAnswered: { type: Number, required: true },
    deadline: { type: String, required: true },
    questionsInfo: { type: Array<TestQuestion>, required: true },
    activeQuestion: {
        type: Object as PropType<ActiveQuestion>,
        required: true,
    },
    questionOptions: { type: Array<QuestionOption>, required: true },
    show_correct_option: { type: Boolean, required: true },
    biometry_capture_route: { type: String, required: true },
    test_over: { type: Boolean, required: true },
    test_middle: { type: Boolean, required: true },
    ws_exam: { type: String, required: true },
    ws_subtenant_notification: { type: String, required: true },
    ws_webcam: { type: String, required: true },
    is_ws_verification: { type: Boolean, required: true },
    is_agent_support_ws_verification: { type: Boolean, required: true },
    computer_uid: { type: String, required: true },
    logout_url: { type: String, required: true },
    ws_schedule_notification: { type: String, required: true },
    get_time_url: { type: String, required: true },
	get_timer_data_url: { type: String, required: false, default: null },
    descricao_computer: { type: String, required: true },
    webcam_webrtc_streaming_source: { type: String, required: true },
    streaming_auth_credential: { type: String, required: true },
    browser_webcam_streaming_enabled: { type: Boolean, required: false, default: false },
});

onMounted(() => {
    common.startKeyUp();

    checkConnection(props, connectionStatus, connectionSpinner);

    setInterval(() => {
        checkConnection(props, connectionStatus, connectionSpinner);
    }, 25000);

});

const questionInfoSorted = computed(() => {
    return props.questionsInfo.sort((a, b) => {
        return a.sequence - b.sequence;
    });
});

const logout_exam_url: string = usePage().props
    ?.logout_exam_url_global as string;

const key_active_question = ref(0);
const reload = ref(false);

emitter.on('exam_expired', (event) => {
    if (event.type === 'exam_timeout') {
        const messageType = event.type;
        test_over_captures('danger', messageType);
    }
});

emitter.on('reload_question', (e) => reload_question(e));

function reload_question(event) {
    reload.value = true;

    const loading = showLoadingModal();

    try {
        router.reload({
            data: {
                reload: reload.value,
                sequence: props.activeQuestion.sequence,
                action: event.action,
                specific_sequence: event.specific_sequence,
            },
            only: [
                'activeQuestion',
                'questionOptions',
                'questionsInfo',
                'totalAnswered',
                'test_over',
                'test_middle',
                'deadline',
                'computer_uid',
                'is_ws_verification',
                'is_agent_support_ws_verification',
            ],
            onSuccess: (page) => {
                common.set_option_checked(
                    (page.props.activeQuestion as any).testQuestion
                        .selected_question_option_id
                );
                key_active_question.value = key_active_question.value + 1;
                reload.value = false;
            },
            onFinish: (visit) => {
                loading.close();
                checkComputerUUID(props.computer_uid, props.logout_url, props.descricao_computer, props.is_ws_verification, props.is_agent_support_ws_verification);
				emitter.emit('reload_question_finished');
            },
            preserveState: false,
        });
    } catch (error) {
        loading.close();

        alert('Ocorreu um erro ao carregar a próxima pergunta: ' + error);
    }
}

function showLoadingModal() {
    return Swal.fire({
        timerProgressBar: true,
        allowOutsideClick: false,
        showConfirmButton: false,
        width: '300px',
        html: `<div style="width: 250px; height: 75px;">
				<div class="text-modal" style="margin: 1.5rem; text-align: center; align-self: center;"
				>
					Aguarde um momento
				</div>
				<div class="mt-1">
					<i class="fas fa-lg fa-sync fa-spin"> </i>
				</div>
			</div>`,
    });
}

function test_over_captures(
    type: string = 'success',
    message: string = 'test-over'
) {
    router.get(props.biometry_capture_route, {
        type: type,
        message: message,
    });
}

function test_middle_captures() {
    router.get(props.biometry_capture_route, {
        type: 'info',
        message: 'test-middle',
    });
}

onUpdated(() => {
    if (props.test_middle) {
        test_middle_captures();
    }
    if (props.test_over) {
        test_over_captures();
    }
});

onMounted(() => {
    common.set_computer_id(props.computerId);
    if (common.current_path_name === window.location.pathname) {
        common.connect_ws(props.ws_exam);
        common.connect_ws(props.ws_subtenant_notification);
        common.connect_ws(props.ws_schedule_notification);
    }
});
</script>

<style scoped>
.btn-logout {
    border-color: #fff;
    color: #ff662a;
    background-color: #fff;
}

.btn-logout:hover {
    border-color: #00a3ff;
    color: #00a3ff;
}

.student_info {
    background-color: #ff662a;
    color: white;
    font-weight: bold;
    font-size: large;
    text-transform: uppercase;
}
</style>
